module.exports = __webpack_public_path__ + "img/16800.08d06fce.jpg";